export class SingleHSCodePredictions implements IResponseList<TypeSingleHSCodePrediction> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: TypeSingleHSCodePrediction[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_docs_count: number;
  total_records: number;
  constructor() {
    this.status_code = 0
    this.data = []
    this.page = 0
    this.page_size = 0
    this.total_pages = 0
    this.total_docs_count = 0
    this.total_records = 0
  }

}